import React from 'react';
import { PlayCircle, Plus, GripVertical, FileText, X } from 'lucide-react';

interface SelectedModule {
  id: number;
  title: string;
  type: string;
  duration: string;
}

interface BlendedCourseProps {
  selectedModules: SelectedModule[];
  onOpenModulesModal: () => void;
  onRemoveModule: (moduleId: number) => void;
}

const BlendedCourse: React.FC<BlendedCourseProps> = ({
  selectedModules,
  onOpenModulesModal,
  onRemoveModule,
}) => {
  return (
    <div className="admin-coursemanagement-form-section">
      <div className="admin-coursemanagement-section-header">
        <div className="admin-coursemanagement-section-icon admin-coursemanagement-orange">
          <PlayCircle size={24} color="white" />
        </div>
        <div>
          <h3>Course Modules ({selectedModules.length})</h3>
        </div>
        <button
          className="admin-coursemanagement-add-offering-btn"
          onClick={onOpenModulesModal}
        >
          <Plus size={16} /> Add Modules
        </button>
      </div>

      {selectedModules.length === 0 ? (
        <div className="admin-coursemanagement-empty-state">
          <div className="admin-coursemanagement-empty-icon">
            <PlayCircle size={48} />
          </div>
          <p className="admin-coursemanagement-empty-subtitle">
            No modules added yet. Click "Add Modules" to get started.
          </p>
        </div>
      ) : (
        <div className="admin-coursemanagement-modules-list">
          {selectedModules.map((module, index) => (
            <div key={module.id} className="admin-coursemanagement-module-item">
              <div className="admin-coursemanagement-module-drag">
                <GripVertical size={20} />
              </div>
              <div className="admin-coursemanagement-module-number">{index + 1}.</div>
              <div className="admin-coursemanagement-module-icon">
                <FileText size={24} color="#FF8C00" />
              </div>
              <div className="admin-coursemanagement-module-info">
                <p className="admin-coursemanagement-module-title">{module.title}</p>
                <p className="admin-coursemanagement-module-meta">
                  {module.type} • {module.duration}
                </p>
              </div>
              <button
                className="admin-coursemanagement-icon-btn"
                onClick={() => onRemoveModule(module.id)}
              >
                <X size={18} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BlendedCourse;
